export const firebaseConfig = {
  apiKey: 'AIzaSyDIPUlb59yf4Q-qzAdiumQTBnU7eWoSrZg',
  authDomain: 'copyrighter.firebaseapp.com',
  projectId: 'copyrighter',
  storageBucket: 'copyrighter.appspot.com',
  messagingSenderId: '409494786973',
  appId: '1:409494786973:web:138d40a5d8f4d748385574',
  measurementId: 'G-F018EK8LN8'
}